export default __webpack_public_path__ + "static/how-it-works-phase-1-mobile-3cd9c6d787d62106686779816c0b411d.svg";